import Vue from 'vue';
import Vuex from 'vuex';
import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
  	apiUrl: process.env.VUE_APP_API_URL,
  	baseUrl: process.env.VUE_APP_BASE_URL,
    appVersion: process.env.VUE_APP_VERSION,
    imgUrl: 'productos/files/img/',
    pdfUrl: 'productos/files/pdf/',
    locales: ['es', 'en'],            // idiomas permitidos
    favlistsLocalesEnabled: ['es'],   // vibiblidad de lista de favoritos por idioma
    locale: '',
    loggedIn: false,
    username: '',
    userEmail: '',
    userSrv: '',
    sessionType: null,
    sessionEndTime: null,
    shoppingCart: [],
    shoppingCartLoading: false,
    globalMessage: {},
    punchOutUrl: '',    
    services: [],  // Filled on checkSession
    selectedService: localStorage.getItem("selectedService") === null ? 0 : JSON.parse(localStorage.getItem("selectedService")),
    selectedFavlist: localStorage.getItem("selectedFavlist") === null ? 0 : JSON.parse(localStorage.getItem("selectedFavlist")),
    adVisibility: sessionStorage.getItem("adVisibility") === null ? 1 : JSON.parse(sessionStorage.getItem("adVisibility")),
  },
  actions,
  getters,
  mutations,
  modules: {
  },
  
})
